<template>
    <router-view/>
</template>

<style lang="less">
    #app {
        width: 100%;
    }
</style>
